import { getIntegrationsRoute } from '../../route'

interface IntegrationMetadata {
  readonly title: string
  readonly icon: string
  readonly iconClass?: string
  readonly getUrlRoute: () => string
  readonly connectToLabelId: string
}

export const integrationsMetadata: {
  readonly microsoftTeams: IntegrationMetadata
  readonly slack: IntegrationMetadata
  readonly gitHub: IntegrationMetadata
  readonly azureBoards: IntegrationMetadata
  readonly jira: IntegrationMetadata
  readonly agileCentral: IntegrationMetadata
  readonly pagerDuty: IntegrationMetadata
  readonly victorOps: IntegrationMetadata
  readonly generic: IntegrationMetadata
  readonly jenkins: IntegrationMetadata
  readonly [key: string]: IntegrationMetadata
} = {
  microsoftTeams: {
    title: 'Microsoft Teams',
    icon: 'images/integrations/microsoft-teams-logo.png',
    iconClass: 'bugzilla-icon',
    getUrlRoute: () => `${getIntegrationsRoute()}/microsoftteams`,
    connectToLabelId: 'detail_integrationsSettings_connectToMicrosoftteams'
  },
  slack: {
    title: 'Slack',
    icon: 'images/integrations/slackIcon.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/slack`,
    connectToLabelId: 'detail_integrationsSettings_connectToSlack'
  },
  gitHub: {
    title: 'Github',
    icon: 'images/integrations/gitHubIcon.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/github`,
    connectToLabelId: 'detail_integrationsSettings_connectToGitHub'
  },
  azureBoards: {
    title: 'Azure Boards',
    icon: 'images/integrations/azureboards.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/vsts`,
    connectToLabelId: 'detail_integrationsSettings_connectToVisualStudio'
  },
  jira: {
    title: 'Jira',
    icon: 'images/integrations/jiraIcon.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/jira`,
    connectToLabelId: 'detail_integrationsSettings_connectToJira'
  },
  agileCentral: {
    title: 'Agile Central',
    icon: 'images/integrations/agileCentralIcon.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/agilecentral`,
    connectToLabelId: 'detail_integrationsSettings_connectToAgileCentral'
  },
  pagerDuty: {
    title: 'PagerDuty',
    icon: 'images/integrations/pagerduty.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/pagerduty`,
    connectToLabelId: 'detail_integrationsSettings_connectToPagerDuty'
  },
  victorOps: {
    title: 'VictorOps',
    icon: 'images/integrations/victorOpsIcon.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/victorops`,
    connectToLabelId: 'detail_integrationsSettings_connectToVictorOps'
  },
  generic: {
    title: 'Generic Webhook',
    icon: 'images/integrations/webhookIcon.png',
    getUrlRoute: () => `${getIntegrationsRoute()}/webhook`,
    connectToLabelId: 'detail_integrationsSettings_connectToWebhook'
  },
  jenkins: {
    title: 'Jenkins',
    icon: 'images/integrations/jenkins.png',
    iconClass: 'bugzilla-icon',
    getUrlRoute: () => `${getIntegrationsRoute()}/jenkins`,
    connectToLabelId: 'detail_integrationsSettings_connectToJenkins'
  }
}
